// Redesign class map for the legacy legal `pageContent.js` JSX.
//
// The legacy static pages (PrivacyPolicy / CookiePolicy / TermsOfService) build their content via a
// `pageContent(classes) => [...]` factory whose JSX references MUI `classes.*` keys (a `withStyles`
// object). We reuse that exact JSX verbatim (legal text is legally significant, see docs/redesign.md
// "Migrated pages: Legal") and feed it this redesign Tailwind class map instead of the MUI one, so the
// few layout-bearing wrappers (`wrapper`, `list`, `termsList`, ...) keep their structure on redesign
// tokens. Keys mirror the legacy `style.js` files across all three pages, so a single map serves all.
//
// `section` / `sectionTitle` are applied by the legacy index files, which we do NOT reuse (the redesign
// renders sections itself), but they are kept here so the same object is safe to pass to every
// `pageContent(classes)` call.
export const legalClasses = {
    // Privacy + Terms: the bulleted lists inside sections.
    list: 'mt-2 list-disc space-y-3 pl-6 marker:text-muted-foreground',
    // Terms: the bulleted lists (legacy `termsList`, wider indent).
    termsList: 'mt-2 list-disc space-y-3 pl-6 marker:text-muted-foreground',
    // Cookie: the definition list wrapper (legacy `wrapper`, indented block of strong/span pairs).
    wrapper: 'mt-2 pl-4',
    // Privacy TOC wrapper + nested link list (reused by the verbatim legacy Anchors component).
    listWrapper: 'pb-2',
    listOfLinks: 'space-y-1.5 pl-4 text-sm [&_ul]:mt-1.5 [&_ul]:space-y-1.5 [&_ul]:pl-4',
    // Terms: the per-section plain-English summary box (legacy `mainParagraph`).
    mainParagraph: 'rounded-lg border border-solid border-border bg-card/60 p-4 text-sm text-muted-foreground',
    // Terms: the centered trailing effective-date line (legacy `info`).
    info: 'mx-auto mt-10 w-full max-w-2xl text-center text-sm text-muted-foreground',
    // Applied by the legacy index files only (not used by the redesign renderer); kept for safety.
    section: '',
    sectionTitle: '',
};
